import { Card, CardContent } from '@/components/ui/card';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { useLanguage } from '@/i18n/LanguageContext';
import { CHART_COLORS } from '@/components/admin/analytics/chartColors';

const ChartTooltip = ({ active, payload, label, currency }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-card border border-border rounded-sm px-3 py-2 shadow-lg">
      <p className="text-xs text-muted-foreground mb-1">{label}</p>
      {payload.map((entry) => (
        <p key={entry.dataKey || entry.name} className="text-sm font-bold" style={{ color: entry.color }}>
          {entry.name}: {currency && 'CHF '}
          {typeof entry.value === 'number' ? entry.value.toFixed(currency ? 2 : 0) : entry.value}
        </p>
      ))}
    </div>
  );
};

export const RevenueBreakdownPie = ({ revenueBreakdown }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <h3 className="text-lg font-bold mb-4">{t('analytics.revenueBreakdown')}</h3>
        {revenueBreakdown.length > 0 ? (
          <div className="h-64 flex flex-col items-center">
            <ResponsiveContainer width="100%" height="80%">
              <PieChart>
                <Pie
                  data={revenueBreakdown}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  strokeWidth={2}
                  stroke="hsl(var(--card))"
                >
                  {revenueBreakdown.map((d, i) => (
                    <Cell key={d.name} fill={CHART_COLORS[i % CHART_COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip content={<ChartTooltip currency={true} />} />
              </PieChart>
            </ResponsiveContainer>
            <div className="flex flex-wrap gap-3 justify-center">
              {revenueBreakdown.map((d, i) => (
                <div key={d.name} className="flex items-center gap-1.5 text-xs text-muted-foreground">
                  <div className="w-2.5 h-2.5 rounded-full" style={{ background: CHART_COLORS[i % CHART_COLORS.length] }} />
                  {d.name}: CHF {d.value.toFixed(2)}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="h-64 flex items-center justify-center text-muted-foreground text-sm">
            {t('analytics.noData')}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
